import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import { Img } from "@randajan/jet-react/dom/img";
//import { Tile } from "@randajan/jet-react/dom/tile";
//import { Counter } from "@randajan/jet-react/dom/counter";

import "./ShopStuff.scss";

const disableRightClick = ev => {
    ev.preventDefault();
}

export const ShopStuff = (props) => {
    const { id, priceTag, sizeTag, clickCount, shopCategory } = props;

    const img = `/api/drive/shopStuffs/${id}_img`;
    const href = `/api/redirect/shopStuffs/${id}`;

    const go = ev => {
        window.open(href);
        ev.preventDefault();
    }

    const height = Number.jet.frame(shopCategory?.imgsHeight || 50, 10, 100);

    return (
        <Block className="ShopStuff withShadeHover" onClick={go} onContextMenu={disableRightClick}>
            <div className="frame">
                <Img src={img} style={{height:height + "vh"}}/>
                <div className="tagZone">
                    <span className={"placeholder"}/>
                    <span className={["sizeTag", !sizeTag && "placeholder"].join(" ")}>{sizeTag}</span>
                    <span className="countTag">
                        {/* <Counter duration={2000}>{clickCount}</Counter> */}
                    </span>
                    <span className="priceTag">{priceTag}</span>
                </div>
            </div>
        </Block>
    )
}

